/*
 * MDB shim for MDBNavItem
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueView.jsx
 * - src/Seating/Reports/dailyOrderCounts.jsx
 * - src/Seating/Tasks/Tasks.jsx
 */

export default function MDBNavItem({ children }) {
    return children;
}
